import { render } from "./StartView.vue?vue&type=template&id=1381ab75&ts=true"
import script from "./StartView.vue?vue&type=script&lang=ts"
export * from "./StartView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__